import { render } from "./PromptPopup.vue?vue&type=template&id=48ddf55a&scoped=true&ts=true"
import script from "./PromptPopup.vue?vue&type=script&lang=ts"
export * from "./PromptPopup.vue?vue&type=script&lang=ts"

import "./PromptPopup.vue?vue&type=style&index=0&id=48ddf55a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_au_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ddf55a"]])

export default __exports__